import { Directive, OnDestroy } from '@angular/core';
import { MonoTypeOperatorFunction, Subject, takeUntil } from 'rxjs';

@Directive() // Needed only for Angular v9+ strict mode that enforce decorator to enable Component inheritance
export abstract class Destroyable implements OnDestroy {
    protected readonly _destroy = new Subject<void>();

    public readonly destroy$ = this._destroy.asObservable();

    ngOnDestroy(): void {
        this._destroy.next();
        this._destroy.complete();
    }
}

/**
 *
 * @param destroyable - only implementation of `Destroyable` can use this operator.
     It exposes destroy subject that will be hooked in observable pipe as `takeUntil(destroy$)`
     and will trigger it in `ngOnDestroy()` seamlessly

 * @returns rxjs operator to be use in observable pipe

 * @example
        class DestroyableComponent extends Destroyable {
            constructor() {
                super();

                interval(1000).pipe(takeUntilDestroy(this));
            }
        }
 */
export function takeUntilDestroy<T>(destroyable: Destroyable): MonoTypeOperatorFunction<T> {
    return takeUntil(destroyable.destroy$);
}
